'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import { usePublicProfileDataQuery } from '../../hooks/use-public-profile-data-query';
import { OverviewGameCard } from '../overview-game-card';
import * as Styled from './profile-overview.styled';
export const PublicProfileOverview = React.memo(function PublicProfileOverview() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const {
    data,
    isLoading
  } = usePublicProfileDataQuery();
  const lastPlayedGame = React.useMemo(() => {
    if (!data || !profileModel.repeaters.games) {
      return undefined;
    }
    return profileModel.repeaters.games.find(game => parseInt(game.options.gameId, 10) === data.lastGameId);
  }, [data, profileModel.repeaters.games]);
  if (!data || isLoading) {
    return null;
  }
  return <Styled.ColumnsWrapper>
      <Styled.Column>
        <Styled.ColumnCard>
          <Styled.ColumnCardTitle>{profileModel.strings.personalInformation}</Styled.ColumnCardTitle>

          <Styled.TextRow {...buildQaTrackingEntityProps('newProfile.info.nickName')}>
            <Styled.ColumnCardLightText>{profileModel.strings.nickName}</Styled.ColumnCardLightText>
            <Styled.ColumnCardDarkText>{data.name}</Styled.ColumnCardDarkText>
          </Styled.TextRow>

          {data.about ? <>
              <Styled.TextRow {...buildQaTrackingEntityProps('newProfile.info.about')}>
                <Styled.ColumnCardLightText>{profileModel.strings.aboutMe}</Styled.ColumnCardLightText>
                <Styled.ColumnCardDarkText>{data.about}</Styled.ColumnCardDarkText>
              </Styled.TextRow>
            </> : null}
        </Styled.ColumnCard>
      </Styled.Column>
      {lastPlayedGame ? <Styled.Column>
          <OverviewGameCard image={lastPlayedGame.images.image} gameIcon={lastPlayedGame.images.gameIcon} title={lastPlayedGame.strings.title} aboveTitleText={profileModel.strings.recentlyPlayed} url={lastPlayedGame.links.url} />
        </Styled.Column> : null}
    </Styled.ColumnsWrapper>;
});